import { useEffect, useState } from 'react';

import { removeDataFromStorage } from '@/utilities/dataStorage';

import { home } from '@/constants/routes';

import { ProfileOptions } from './models';

import { signOutService } from '@/client/services/core/auth/methods';
import { getProfileService } from '@/client/services/core/user/methods';
import { GetProfileResponseType } from '@/client/services/core/user/models';

export function useProfile(profileOptions?: ProfileOptions) {
    const [profile, setProfile] = useState<GetProfileResponseType | null>(null);
    const [isProfileLoading, setIsProfileLoading] = useState<boolean>(true);

    const fullName = `${profile?.firstName || ''} ${profile?.lastName || ''}`;

    const loadProfile = async () => {
        setIsProfileLoading(true);
        try {
            const profileResponse = await getProfileService();
            setProfile(profileResponse.data);
            return profileResponse.data;
        } catch (error) {
        } finally {
            setIsProfileLoading(false);
        }
    };

    useEffect(() => {
        if (profileOptions?.shouldFetchProfile) {
            void loadProfile();
        } else {
            setIsProfileLoading(false);
        }
    }, []);

    const logout = async () => {
        try {
            setIsProfileLoading(true);
            await signOutService();
            removeDataFromStorage('tokens', 'cookie');
            window.location.href = home;
        } catch (error) {
        } finally {
            setIsProfileLoading(false);
        }
    };

    return { profile, fullName, loadProfile, logout, isProfileLoading };
}
